<template>

<div>
    <div class="row" v-if='status == 0'>

        <div class="col-12">
            <div class="input-group mt-3 mb-4">
                <label class="label d-flex justify-content-between align-items-center w-100 mb-0" for='title'>
                    Tool Name 
                    <span>{{ model.title.length }} / 60</span>
                </label>
                <div class="input-group-prepend">
                    <span class="input-group-text" id="email-icon">
                        <span class="icon icon-label"></span>
                    </span>
                </div>
                <input type="text" id="title" v-model.trim='model.title' class='form-control' placeholder="AI Tool Name">
            </div>
        </div>

        <div class="col-12">
            <div class="input-group mb-4">
                <label class="label d-flex justify-content-between align-items-center w-100 mb-0" for='url'>
                    Website 
                    <span>{{ model.website.length }} / 80</span>
                </label>
                <div class="input-group-prepend">
                    <span class="input-group-text" id="email-icon">
                        <span class="icon icon-link1"></span>
                    </span>
                </div>
                <input type="url" id='website' class='form-control' v-model.trim='model.website' placeholder="https://website-name.ai">
            </div>
        </div>

        <div class="col-12">
            <div class="input-group mb-4">
                <label class="label d-flex justify-content-between align-items-center w-100 mb-0" for='info'>
                    Description 
                    <span>{{ model.info.length }} / 500</span>
                </label>
                
                <div class="input-group-prepend">
                    <span class="input-group-text" id="email-icon">
                        <span class="icon icon-writing"></span>
                    </span>
                </div>
                <textarea class='form-control' id='info' rows=6 
                      placeholder="A brief info about the tool" v-model.trim='model.info'></textarea>
            </div>
        </div>

        <div class="col-12 mt-3 text-center">
            <button @click='submit' class='btn btn-primary btn-lg' :disabled='isLoading'>
                <span v-if='!isLoading'>Submit Tool</span>
                <img src="/resources/loader.svg" width="25px" v-if='isLoading'>
            </button>
        </div>
    </div>

    <div class="row" v-if='status != 0'>
        <div class="col-12">

            <div class="alert alert-success" role="alert" v-if='status == 1'>
                <div class="alert-icon">
                    <span class="icon icon-smile1"></span>
                </div>
                <div class="d-flex justify-content-between align-items-center w-100">
                    <div>
                        <span class="text-bold d-block">Great!</span>
                        <span class="text-small">Your tool was submited. <a href='/submit-ai-tool'>Submit more tools</a></span>
                    </div>
                </div>
            </div>

            <div class="alert alert-warning" role="alert" v-if='status == 2'>
                <div class="alert-icon">
                    <span class="icon icon-sad"></span>
                </div>
                <div class="d-flex justify-content-between align-items-center w-100">
                    <div>
                        <span class="text-bold d-block">Ops!</span>
                        <span class="text-small">{{ errMsg }}</a></span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
        },

        data() { 

            return {
                isReady : false,
                isLoading : false,
                status : 0,

                model : {
                    title : '',
                    website : '',
                    info    : ''
                }
            }
            
        },

        methods : {

            submit() {

                if( this.model.title.length < 2 ) {
                    $.notify("Please add a valid tool name","warning");
                    $("#title").focus();
                    return;
                }

                var expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
                var regex = new RegExp(expression);

                if ( !this.model.website.match(regex)) {
                    $.notify("Please add a valid website URL","warning");
                    $("#website").focus();
                    return;
                } 

                this.isLoading = true;

                this.ajax.call('tl:sbm', this.model, (r) => {
                    if( r.status == 'success' ) {

                        this.status = 1;

                    } else {

                        this.status = 2;
                        this.errMsg = r.message;
                        
                        $.notify( r.message, 'warning');

                    }
                })
            }
        },

        //60-80-500
        watch : {
            "model.title" : function(n,o) {
                if( n.length > 60 ) {
                    this.model.title = this.model.title.substr(0,60);
                }
            },
            "model.website" : function(n,o) {
                if( n.length > 80 ) {
                    this.model.website = this.model.website.substr(0,80);
                }
            },

            "model.info" : function(n,o) {
                if( n.length > 500 ) {
                    this.model.info = this.model.info.substr(0,500);
                }
            },
        }

    }
</script>
